// extracted by mini-css-extract-plugin
export default {"switchContainer":"DeleteChatMatrix_switchContainer_K6H7G"};